import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useMsal} from '@azure/msal-react';
import {InteractionStatus} from '@azure/msal-browser';
import Loading from '../../components/loading';
import auth from '../../lib/auth';
import {loginRequest} from '../../lib/entra-auth/entra-auth-config';

export default function NetworkOptimizationLoginPage() {
    const navigate = useNavigate();
    const {instance, inProgress} = useMsal();
    const [error, setError] = useState<string | null>(null);

    if (!auth.isExpired()) {
        navigate(auth.getLandingPageUrl());
        return null;
    }

    // Must wait for inProgress===None: MsalProvider fires handleRedirectPromise() after child effects, which clears interaction.status if called while loginRedirect is already set but browser hasn't navigated yet.
    useEffect(() => {
        if (inProgress !== InteractionStatus.None) {
            return;
        }
        sessionStorage.setItem('post_login_redirect', '/network-optimization');
        auth.clearMsalCache();
        instance.loginRedirect({...loginRequest, prompt: 'login'}).catch(() => {
            sessionStorage.removeItem('post_login_redirect');
            setError('Login failed. Please try again.');
        });
    }, [inProgress]);

    return (
        <div className='w-full h-screen flex justify-center items-center flex-col'>
            {error
                ? <div className='text-center text-red-500'>
                    {error}{' '}
                    <a href='/network-optimization/login'>Retry</a>
                </div>
                : <Loading large />
            }
        </div>
    );
}
